import { DASH } from "../../utils/dash";
import styles from "./SourceDataStates.module.css";

function badgeClass(label: string): string {
  if (label === "Approved") return `${styles.badge} ${styles.badgeOk}`;
  if (label === "Rejected" || label === "Trash") return `${styles.badge} ${styles.badgeNo}`;
  if (label === "Pending" || label === "Scheduled") return `${styles.badge} ${styles.badgePending}`;
  return styles.badge;
}

type StatusBadgeProps = {
  label: string | null;
  /** "approval-status" in a card head, "item-status" on a list item. */
  testId: "approval-status" | "item-status";
};

/** A status as sent, coloured by the states it is known for; a dash when there is none. */
export function StatusBadge({ label, testId }: StatusBadgeProps) {
  if (label === null) {
    return (
      <span className={styles.dash} data-testid={testId}>
        {DASH}
      </span>
    );
  }
  return (
    <span className={badgeClass(label)} data-testid={testId}>
      {label}
    </span>
  );
}

/** The state for a firm the panel cannot look content up for. */
export function UnknownState({ title, sentence }: { title: string; sentence: string }) {
  return (
    <div className={styles.tab}>
      <h3 className={styles.unknownTitle}>{title}</h3>
      <p className={styles.unknownText}>{sentence}</p>
    </div>
  );
}

/** The state for a request that failed. */
export function ErrorState({ message }: { message: string }) {
  return (
    <div className={styles.tab}>
      <div role="alert" className={styles.error}>
        {message}
      </div>
    </div>
  );
}
